// A next/dynamic chunk only starts downloading when the component mounts. Calling the same module
// specifier here, on a gesture that precedes the click, warms webpack's module cache so the dynamic's
// own import() resolves from memory. The .catch is mandatory: a prefetch that fails offline must not
// become an unhandled rejection just because the user hovered a button.
//
// It is a named indirection rather than an inline `void import(...)` so call sites are observable in
// tests — an inline import() of a mocked module returns the mock and records no call, which makes any
// prefetch assertion vacuously green.
export function prefetchModule(loader: () => Promise<unknown>): void {
  loader().catch(() => {});
}
